import React, { useState } from 'react';
import { agreeToTermsApi } from "../../api";
import { useNavigate } from "react-router-dom";
import { Checkbox, PrimaryButton, Text } from '@fluentui/react'; // Fluent UI components
import { Stack } from '@fluentui/react/lib/Stack';  // Stack for layout

const LegalDocument: React.FC = () => {
    const [agreed, setAgreed] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    const handleAgreement = async () => {
        const abortController = new AbortController();
        if (agreed) {
            const user = localStorage.getItem('user');
            if (!user) {
                setError('User not found.');
                return;
            }
            // API call to update user status
            const response = await agreeToTermsApi(JSON.parse(user), abortController.signal);
            if (response.status === 200) {
                const userData = JSON.parse(user);
                userData.agree_to_terms = true;
                localStorage.setItem('user', JSON.stringify(userData));
                navigate('/home');
            } else {
                setError('Failed to agree to terms.');
            }
        } else {
            alert("You must agree to the terms to proceed.");
        }
    };

    return (
        <div style={{ maxWidth: '600px', margin: '50px auto', padding: '20px' }}>
            <Stack tokens={{ childrenGap: 20 }}>
                <Text variant="xLarge" block>
                    Tufin AI Design Partners Agreemen
                </Text>

                <Text variant="medium" block>
                    Dear Customer,
                    <br/><br/>
                    Thank you for agreeing to participate in Tufin’s AI Design Partner Program (the “Program”) to incorporate AI-powered tools (the “Tool”) into our software.
                    We appreciate your contribution and feedback and value your time and effort.
                    <br/><br/>
                    Before joining the Program, we ask that you agree to the following legalese by signing below:
                    <ul>
                        <li>To keep all details about the Program confidential.</li>
                        <li>That all feedback provided shall be owned by Tufin with the purpose of improving the Tool.</li>
                        <li>That as the Tool is in a prototype phase, Tufin is not responsible if the Tool does not operate properly or if it provides incorrect advice.</li>
                        <li>That neither the Program nor the Tool is intended for use or application in live environments.</li>
                    </ul>
                    We thank you again for joining the Program and look forward to working with you in the Program.
                    <br/><br/>
                    By checking this box, you are agreeing to the above terms of service.
                </Text>

                <Checkbox
                    label="I agree to the terms and conditions"
                    checked={agreed}
                    onChange={(_, checked) => setAgreed(checked || false)}
                />

                {error && <Text variant="small" styles={{ root: { color: 'red' } }}>{error}</Text>}

                <PrimaryButton
                    text="Submit Agreement"
                    onClick={handleAgreement}
                    disabled={!agreed}
                    styles={{
                        root: {
                            backgroundColor: agreed ? '#ff8c00' : '#ffd1a6',  // Set color based on agreed state
                            borderColor: agreed ? '#ff8c00' : '#ffd1a6',
                            width: '100%',
                            padding: '10px',
                        },
                        rootDisabled: {
                            backgroundColor: '#ffd1a6',  // Color when disabled
                            borderColor: '#ffd1a6',
                            color: 'white',
                        },
                        rootHovered: {
                            backgroundColor: agreed ? '#ff751a' : '#ffd1a6',  // Darker when hovered
                            borderColor: agreed ? '#ff751a' : '#ffd1a6',
                        },
                    }}
                />
            </Stack>
        </div>
    );
};

export default LegalDocument;
